import { a11yProps, Tab, Tabs } from 'asterX-UI/Tabs'
import { useTranslation } from 'react-i18next'
import { useHomeStoreManager } from 'context/HomeStore/Manager'
import { Route, Switch } from 'react-router-dom'
import { SubPrivateRoute } from 'routes/PrivateRoute'
import React from 'react'

import { useRouteMatch } from 'react-router'
import PageContainerDesktop from '../../../../components/PageContainer/layout/PageContainer.desktop'
import TasksTab from 'pages/Desktop/Home/Manager/components/Tasks/TasksTab'
import SelectionTab from 'pages/Desktop/Home/Manager/components/Selection/SelectionTab'
import WorkListTab from 'pages/Desktop/Home/Manager/components/WorkLists/WorkListTab'
import { managerSubRoutes } from 'routes/desktopRoutes'
import BonusesTab from './components/Bonuses/BonusesTab'

const HomeManagerDesktop = () => {
  const { t } = useTranslation()
  const { homeStore, homeStoreFunc } = useHomeStoreManager()
  const { path } = useRouteMatch()

  const configTabs = () => [
    { label: t('homePage.manager.tabs.tasks'), value: 0 },
    { label: t('homePage.manager.tabs.selection'), value: 1 },
    { label: t('homePage.manager.tabs.wl'), value: 2 },
    { label: t('homePage.manager.tabs.bonus'), value: 3 }
  ]

  const tabs = [<TasksTab />, <SelectionTab />, <WorkListTab />, <BonusesTab />]

  return (
    <Switch>
      <Route exact path={path}>
        <PageContainerDesktop>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              width: '100%',
              marginBottom: 16
            }}
          >
            <Tabs
              value={homeStore.selectedTab}
              onChange={homeStoreFunc.onChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              indicatorColor="primary"
              textColor="primary"
            >
              {configTabs().map((tab, index) => (
                <Tab
                  label={tab.label}
                  {...a11yProps(tab.value)}
                  value={tab.value}
                  key={`tab_${index}`}
                />
              ))}
            </Tabs>
          </div>

          <div>{tabs[homeStore.selectedTab]}</div>
        </PageContainerDesktop>
      </Route>

      {managerSubRoutes.map(route => (
        <SubPrivateRoute {...route} key={route.path} />
      ))}
    </Switch>
  )
}

export default HomeManagerDesktop
